import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectProducts } from "../../redux/slices/productsSlice";
import { addItem } from "../../redux/slices/cartSlice";
import { saveOrderToLocalStorage } from "../../utils/orderStorage";
import classes from "./CategoryTemplate.module.css";
import shared from "../../Components/OrderShared.module.css";
import ImportantNoteComp from "../../Components/ImportantNoteComp";

export const generateOptions = (product) => {
  const step = product.minQuantity;
  let i = product.minQuantity;
  let options = [];
  while (i <= product.maxQuantity) {
    options.push(<option value={i}>{i}</option>);
    i += step;
  }
  return options;
};

export default function CategoryPageTemplate({
  categoryId,
  categoryData,
  noteCaption = "ℹ️איך זה עובד:",
  noteText = "בחרו מוצר, מלאו פרטים ושלחו בקשת הזמנה. אנחנו נבדוק זמינות ונחזור אליכם לאישור סופי והשלמת ההזמנה.",
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const productsToPurchase = useSelector((state) => state.cart);
  const products = useSelector(selectProducts).filter(
    (product) => product.category === categoryId,
  );
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [items, setItems] = useState({});

  useEffect(() => {
    const navbarHeight = document.getElementsByTagName("nav")[0]?.offsetHeight;

    document.getElementsByClassName(classes.productSearch)[0].style.top =
      `${navbarHeight}px`;
  }, []);

  const handleCommentChange = (id, value) => {
    setItems((prev) => ({
      ...prev,
      [id]: {
        // quantity: prev[id]?.quantity || 0,
        quantity: prev[id]?.quantity,
        userCommentAnswer: value,
      },
    }));
  };

  // const handleQuantityChange = (id, value, minQuantity) => {
  //   const parsed = Number(value || minQuantity);
  //   setItems((prev) => ({
  //     ...prev,
  //     [id]: {
  //       quantity: Math.max(
  //         minQuantity,
  //         Number.isFinite(parsed) ? parsed : minQuantity,
  //       ),
  //       userCommentAnswer: prev[id]?.userCommentAnswer || "",
  //     },
  //   }));
  // };

  const handleQuantityChange = (id, value) => {
    setItems((prev) => ({
      ...prev,
      [id]: {
        quantity: Math.max(0, Number(value || 0)),
        userCommentAnswer: prev[id]?.userCommentAnswer || "",
      },
    }));
  };

  const handleAddToCart = (product) => {
    const qty = Math.max(
      product.minQuantity,
      items[product.id]?.quantity ?? product.minQuantity,
    );

    const itemToAdd = {
      productId: product.id,
      quantity: qty,
      userCommentAnswer: items[product.id]?.userCommentAnswer || "",
    };

    dispatch(addItem(itemToAdd));

    saveOrderToLocalStorage("AddItem", productsToPurchase.items, itemToAdd);
  };

  const handleOrder = () => {
    navigate("/orders/form", {
      state: { order: productsToPurchase },
    });
  };

  const handleBack = () => {
    navigate("/orders");
  };

  return (
    <bdo dir="rtl">
      <div className={classes.categoryContainer}>
        <div className={classes.categoryHeader}>
          <div className={classes.categoryIcon}>{categoryData.icon}</div>
          <h2 className={classes.categoryTitle}>{categoryData.name}</h2>
          <p className={classes.categorySubtitle}>{categoryData.description}</p>
        </div>

        <div className={classes.benefitsCard}>
          <h5 className={classes.sectionTitle}>למה להזמין מאתנו?</h5>
          <ul className={classes.benefitsList}>
            {categoryData.benefits.map((benefit, index) => (
              <li key={index}>
                <span className={classes.checkIcon}>✔️</span>
                {benefit}
              </li>
            ))}
          </ul>
        </div>

        <ImportantNoteComp caption={noteCaption} text={noteText} />

        <div className={classes.productsSection}>
          <div className={classes.productGrid}>
            <input
              type="text"
              className={classes.productSearch}
              placeholder="חיפוש מוצר..."
              onChange={(e) => {
                const searchTerm = e.target.value;
                const filteredProducts = products.filter((product) =>
                  product.name.includes(searchTerm),
                );
                setFilteredProducts(filteredProducts);
              }}
            />
            {filteredProducts.map((product) => {
              const minQuantity = product.minQuantity;
              const selectedQuantity =
                items[product.id]?.quantity ?? minQuantity;

              return (
                <form
                  key={product.id}
                  onSubmit={(event) => {
                    event.preventDefault();
                    handleAddToCart(product);
                  }}
                  className={`${classes.productCard} ${classes.spaceBetween}`}
                >
                  <h6>{product.name}</h6>
                  <img
                    src={product.imageURL}
                    alt={product.name}
                    className={classes.productImage}
                  />

                  <div>
                    <div className={classes.commentSection}>
                      {product.comment ? product.comment : null}
                    </div>

                    <div>
                      <input
                        type="text"
                        required={product.needsCommentAnswer}
                        placeholder={
                          product.needsCommentAnswer ? "חובה למלא" : "לא חובה"
                        }
                        value={items[product.id]?.userCommentAnswer || ""}
                        onChange={(event) =>
                          handleCommentChange(product.id, event.target.value)
                        }
                      />
                    </div>
                    <div className={classes.quantityRow}>
                      <select
                        id={`product-${product.id}-select`}
                        value={selectedQuantity}
                        onChange={(event) =>
                          handleQuantityChange(product.id, event.target.value)
                        }
                      >
                        {generateOptions(product)}
                      </select>
                      <button type="submit" className={classes.addToCartButton}>
                        הוסף לסל
                      </button>
                    </div>
                  </div>
                </form>
              );
            })}
          </div>

          <div className={classes.actionButtons}>
            <button
              onClick={handleOrder}
              className={`${shared.buttonBase} ${shared.buttonPrimary}`}
            >
              המשך לטופס הזמנה
            </button>
            <button
              onClick={handleBack}
              className={`${shared.buttonBase} ${shared.buttonSecondary}`}
            >
              חזור לקטגוריות
            </button>
          </div>
        </div>
      </div>
    </bdo>
  );
}
